export default __webpack_public_path__ + "img/d14fadde14bd59d5618cdeb4d864a600.png";